import React from 'react';
import { Trash } from '@saleshandy/icons';

const DeleteActionFilter = () => (
  <Trash width={16} height={16} className="red-txt-16" /> 
);

export default DeleteActionFilter;
